import { Component, Mixins, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
@Component({})
export default class AssessmentTarckMixin extends Vue {
  // 发布、预览打点采集
  public trackPublish(name: string, source: string) {
    window['sensors'].track('TIKU_Assessment_goto_releaseORpreview', {
      buttonName: name,
      proSource: source
    })
  }
  // 点击发布、保存至测评列表
  public trackRelease(params) {
    window['sensors'].track('TIKU_Assessment_releaseORsave', params)
  }
  // 发布成功、保存成功
  public trackSuccess(params) {
    window['sensors'].track('TIKU_Assessment_releaseORsave_done', params)
  }
  // 点击下载成绩单
  public trackDownloadOrder(params) {
    window['sensors'].track('TIKU_Assessment_results_download', params)
  }
  // 点击组卷
  public trackOrganizingPaper(params) {
    window['sensors'].track('TIKU_Assessment_organizingPaper_clk', params)
  }
  // 编辑了测评_题库_测评
  public trackEditDone(params) {
    window['sensors'].track('TIKU_Assessment_edit_done', params)
  }
  // 删除了测评_题库_测评
  public trackDelete(params) {
    window['sensors'].track('TIKU_Assessment_delete_done', params)
  }
  // 查看测评报告
  public trackViewReport(params) {
    window['sensors'].track('TIKU_Assessment_view report ', params)
  }
}
